import React from "react";
import styles from "./form-footer.module.css";
import CustomButton from "../../common/custom-button/custom-button";

const FormFooter = ({
  handlePreviousButtonClick,
  handleClickNextButton,
  saveButtonLabel,
  cancelButtonLabel = "Back",
}) => (
  <div className={styles.footerContainer}>
    <div className={styles.footerMain}>
      <CustomButton
        title={cancelButtonLabel}
        onClick={handlePreviousButtonClick}
        style={{
          width: "95px",
          height: "40px",
          backgroundColor: "transparent",
          color: "#4A4A4A",
          border: "1px solid #888888",
        }}
        variant="outlined"
      />
      <CustomButton
        onClick={handleClickNextButton}
        title={saveButtonLabel}
        type="submit"
        style={{
          width: "128px",
          height: "40px",
        }}
        variant="outlined"
      />
    </div>
  </div>
);

export default FormFooter;
